<template>
  <div class="w-72 lg:w-60 xl:w-80 2xl:w-96">
    <div
      id="showHeurekaBadgeHere-11"
      class="heureka-widget w-full hidden lg:block"
    />
    <CustomLink
      class="lg:hidden"
      :url="options.reviewsPage"
      :type="LINK_TYPE.NoStyle"
      :blank="true"
    >
      <img
        class="m-auto"
        :src="options.mobileBadgeSrc"
        alt="h! OZ Logo"
      >
    </CustomLink>
  </div>
</template>

<script lang="ts">

import { loadHeurekaWidget } from '~~/helpers/heureka/loadHeurekaWidget';
import type { HeurekaWidgetOptions } from '~~/types/components/Heureka/HeurekaWidgetOptions';
import { LINK_TYPE } from '~~/types/components/Link/LinkType';

export default defineComponent({
  name: 'HeurekaWidget',

  props: {
    options: {
      type: Object as PropType<HeurekaWidgetOptions>,
      required: true,
    },
  },

  setup(props) {

    onMounted(() => {

      loadHeurekaWidget(props.options);

    });

    return {
      LINK_TYPE,
    };

  },
});
</script>

<style>
.heureka-widget a img {
  margin: auto;
}
</style>
